import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/types';

export const selectNotifications = createSelector(
  (state: RootState) => state,
  (state) => state.notify,
);
